<template>
  <div class="breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right" v-if="!isMainPage">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item
        :to="{ path: item.url }"
        v-for="item in breadcrumbList"
        :key="item.id"
        >{{ item.name }}</el-breadcrumb-item
      >
      <el-breadcrumb-item
        v-if="$route.name == 'temporarytasksdetail'"
        to="/project/temporarytasks"
        >返回</el-breadcrumb-item
      >
    </el-breadcrumb>

    <span v-else>主页</span>
  </div>
</template>

<script>
export default {
  /**
   * 组件
   */
  components: {},
  props: [""],
  /**
   * 数字
   */
  data() {
    return {
      breadcrumbList: [],
      isMainPage: false,
    };
  },
  /**
   * 监听Vue实例上的数据变动
   */
  watch: {
    async $route() {
      this.changeBreadcrumb();
    },
  },

  /**
   * 方法、函数
   */
  methods: {
    changeBreadcrumb: async function () {
      // let menuListForDev = await this.$store.getters["menu/menuListForDev"];
      // let leftMenuListForDev = await this.$store.getters[
      //   "menu/leftMenuListForDev"
      // ];
      let menuListForDev = await this.http.get("/menu/getmenulist");
      let leftMenuListForDev = menuListForDev[0];
      let currentRoute = this.$route.path;
      currentRoute =
        currentRoute.indexOf("/project/list/") == 0 ? "/project/list" : currentRoute;
      this.isMainPage = currentRoute == "/main";
      menuListForDev.forEach((item) => {
        item.child.forEach((citem) => {
          if (citem.child.length > 0) {
            citem.child.forEach((ccitem) => {
              if (ccitem.url == currentRoute) {
                this.breadcrumbList = [
                  {
                    name: "首页",
                    id: 0,
                    url: "/main",
                  },
                  {
                    id: item.id,
                    name: item.menuname,
                    url: item.url,
                  },
                  {
                    id: citem.id,
                    name: citem.menuname,
                    url: citem.url,
                  },
                  {
                    id: ccitem.id,
                    name: ccitem.menuname,
                    url: ccitem.url,
                  },
                ];
                this.$forceUpdate();
                return;
              }
            });
          } else {
            if (citem.url == currentRoute) {
              this.breadcrumbList = [
                {
                  name: "首页",
                  id: 0,
                  url: "/main",
                },
                {
                  id: item.id,
                  name: item.menuname,
                  url: item.url,
                },
                {
                  id: citem.id,
                  name: citem.menuname,
                  url: citem.url,
                },
              ];
              this.$forceUpdate();
              return;
            }
          }
        });
      });
      if (this.$route.name == "activityseet") {
        this.breadcrumbList = [
          {
            name: "首页",
            id: 0,
            url: "/main",
          },
          {
            name: "活动列表",
            id: 1,
            url: "/activity/list",
          },
          {
            name: "座位设置",
            id: 2,
            url: "/activity/seetview?acid=" + this.$route.query.acid,
          },
        ];
      }
    },
  },
  /**
   * 完成挂载
   */
  mounted() {},
  /**
   * 更新完成状态
   */
  updated: function () {},
  /**
   * 完成了 data 数据的初始化
   */
  async created() {
    this.changeBreadcrumb();
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/menu/breadcrumb.vue